import React from 'react';
import FormInputFile from '@shared/components/form/FormInputFile';
import { FILE_TYPES } from '@shared/constants/fileTypes';
import { ObservationReportValidator } from '../validators/ObservationReportValidator';
import { showSuccessToast } from '@shared/services/toastService';
import SkeletonWrapper from '@shared/components/skeleton/SkeletonWrapper';

const FIELD_NAMES = {
  FILE: 'file'
};

const LABEL_TEXT = 'Upload Report';

/**
 * @typedef {object} ObservationReportInputFieldsProps
 * @property {string} [observedUserName]
 * @property {boolean} [hideRemoveButton]
 * @property {boolean} [loading]
 */

/**
 * @param {ObservationReportInputFieldsProps} props
 */
export const ObservationReportInputFields = props => {
  const { observedUserName, hideRemoveButton, loading } = props;

  const validateUploadedFile = file => {
    const { error } = ObservationReportValidator.fileSchema.validate({
      type: file.type,
      size: file.size
    });
    return error;
  };

  return (
    <div className='observation-report-documents-form-fields'>
      <SkeletonWrapper show={loading} inheritParentSize>
        <div className='label-area bold'>{observedUserName}: </div>
        <div className='input-file-upload-container'>
          <FormInputFile
            name={FIELD_NAMES.FILE}
            id='file-upload'
            acceptedFileTypes={[FILE_TYPES.XLS, FILE_TYPES.XLSX]}
            validateFile={validateUploadedFile}
            data-testid='file-upload-input'
            hideRemoveButton={hideRemoveButton}
            onRemoveFile={() => {
              showSuccessToast('File successfully removed. Please upload a new file.');
            }}
            label={LABEL_TEXT}
          />
        </div>
      </SkeletonWrapper>
    </div>
  );
};
